// 1391 x 454
const getContainer = (top, left, rotation) => ({
  filled: false,
  top: top / 454 * 100,
  left: left / 1391 * 100,
  rotation,
})

const ICONS = {
  mail: '<svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M22.5 0H2.5C1.125 0 0.0125 1.125 0.0125 2.5L0 17.5C0 18.875 1.125 20 2.5 20H22.5C23.875 20 25 18.875 25 17.5V2.5C25 1.125 23.875 0 22.5 0ZM22.5 5L12.5 11.25L2.5 5V2.5L12.5 8.75L22.5 2.5V5Z" fill="#7395F5"/></svg>',
  card: '<svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5 0H2.5C1.1125 0 0.0125 1.1125 0.0125 2.5L0 17.5C0 18.8875 1.1125 20 2.5 20H22.5C23.8875 20 25 18.8875 25 17.5V2.5C25 1.1125 23.8875 0 22.5 0ZM22.5 17.5H2.5V10H22.5V17.5ZM22.5 5H2.5V2.5H22.5V5Z" fill="#7395F5"/></svg>',
  people: '<svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.53691e-06 17.2624C-0.000538784 16.9788 0.0612916 16.6985 0.181079 16.4417C0.300867 16.1849 0.475656 15.9578 0.692966 15.7766C2.31229 14.465 4.05788 13.3189 5.9038 12.3553L7.29881 20H3.53691e-06V17.2624ZM19.3364 19.997H29.6552V17.4599C29.6557 17.1965 29.5981 16.9362 29.4867 16.6977C29.3753 16.4592 29.2127 16.2484 29.0106 16.0804C27.3849 14.7648 25.6226 13.6289 23.7544 12.6926C23.7268 12.6789 23.7037 12.6576 23.6877 12.6313C23.6716 12.6049 23.6633 12.5746 23.6636 12.5437V10.8361C23.9178 10.4045 24.0911 9.92973 24.175 9.4354C24.3687 9.42021 24.6259 9.13155 24.9043 8.16534C25.2704 6.87097 24.9043 6.64612 24.5775 6.64612C25.4036 2.84809 23.2763 2.83594 23.2763 2.83594C23.0977 2.03987 21.9721 1.21342 20.922 1.43219C19.872 1.65095 17.7084 1.4018 17.7084 1.4018C17.7092 1.55013 17.7421 1.6965 17.8048 1.83081C17.8675 1.96511 17.9585 2.08413 18.0715 2.17964C16.1651 3.35247 16.6008 5.91386 16.7733 6.66132C16.4495 6.66132 16.1167 6.91047 16.4707 8.18053C16.7461 9.16194 17.0033 9.4354 17.2 9.45059C17.2839 9.94492 17.4572 10.4197 17.7114 10.8513V12.5589C17.7118 12.5898 17.7034 12.6201 17.6874 12.6465C17.6713 12.6728 17.6482 12.6941 17.6206 12.7078C17.3785 12.8263 16.6856 13.1787 15.7747 13.7196C14.8004 13.1119 13.9591 12.6409 13.4417 12.3705L12.0406 19.997H19.3394H19.3364ZM12.8788 10.1039C13.1431 9.64766 13.3235 9.14747 13.4114 8.62718C13.6202 8.61198 13.8956 8.32333 14.1921 7.26292C14.5825 5.87133 14.1921 5.62825 13.8411 5.64344C14.7277 1.56588 12.4461 1.55372 12.4461 1.55372C12.2555 0.699927 11.045 -0.187293 9.91935 0.0345118C8.79367 0.256317 6.46967 0.00412746 6.46967 0.00412746C6.4702 0.163245 6.5051 0.320353 6.57197 0.464611C6.63885 0.608868 6.73609 0.73684 6.857 0.839694C4.82048 2.10368 5.28649 4.83826 5.47108 5.64344C5.12309 5.64344 4.76601 5.91083 5.14729 7.26596C5.4499 8.31726 5.71921 8.61502 5.92801 8.63021C6.01603 9.15049 6.19642 9.65066 6.46059 10.1069V11.4225L9.35954 13.5494L8.27016 14.941L9.00247 16.123L8.43357 19.997H10.8937L10.3369 16.1108L11.0692 14.9289L9.98593 13.5403L12.8849 11.4134L12.8788 10.1039Z" fill="#FF0000"/></svg>',
  talk: '<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.42098 11.5773C10.7464 11.5773 12.6315 9.69219 12.6315 7.36678C12.6315 5.04137 10.7464 3.15625 8.42098 3.15625C6.09557 3.15625 4.21045 5.04137 4.21045 7.36678C4.21045 9.69219 6.09557 11.5773 8.42098 11.5773Z" fill="#FF0000"/><path d="M8.42105 13.6842C5.61053 13.6842 0 15.0947 0 17.8947V20H16.8421V17.8947C16.8421 15.0947 11.2316 13.6842 8.42105 13.6842ZM16.5895 3.53684L14.8211 5.31579C15.7053 6.5579 15.7053 8.16842 14.8211 9.41053L16.5895 11.1895C18.7158 9.06316 18.7158 5.85263 16.5895 3.53684ZM20.0737 0L18.3579 1.71579C21.2737 4.89474 21.2737 9.67368 18.3579 13.0211L20.0737 14.7368C24.1789 10.6421 24.1895 4.26316 20.0737 0Z" fill="#FF0000"/></svg>',
  question: '<svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 20H8.33333V16.6667H5V20ZM6.66667 0C2.98333 0 0 2.98333 0 6.66667H3.33333C3.33333 4.83333 4.83333 3.33333 6.66667 3.33333C8.5 3.33333 10 4.83333 10 6.66667C10 10 5 9.58333 5 15H8.33333C8.33333 11.25 13.3333 10.8333 13.3333 6.66667C13.3333 2.98333 10.35 0 6.66667 0Z" fill="#FF0000"/></svg>',
}

const data = () => ({
  cards: [
    {
      type: 'user',
      icon: ICONS.mail,
      title: 'Получает СМС от банка с паролем для завершения перевода',
      order: 5,
    },
    {
      type: 'user',
      icon: ICONS.mail,
      title: 'Сообщает СМС-код мошеннику',
      order: 7,
    },
    {
      type: 'user',
      icon: ICONS.card,
      title: 'Сообщает персональную информацию (номер карты, дату, CVV-код)',
      order: 3,
    },
    {
      type: 'cheater',
      icon: ICONS.people,
      title: 'Звонит. Представляется сотрудником банка.',
      order: 0,
    },
    {
      type: 'cheater',
      icon: ICONS.talk,
      title: 'Рассказывает «историю» про взлом карты.',
      order: 1,
    },
    {
      type: 'cheater',
      icon: ICONS.mail,
      title: 'Вводит СМС-код и завершает денежный перевод',
      order: 8,
    },
    {
      type: 'cheater',
      icon: ICONS.question,
      title: 'Задает вопросы, чтобы узнать персональную информацию',
      order: 2,
    },
    {
      type: 'cheater',
      icon: ICONS.card,
      title: 'Вводит данные карты в форму для перевода денег',
      order: 4,
    },
    {
      type: 'cheater',
      icon: ICONS.mail,
      title: 'Просит сообщить СМС-код',
      order: 6,
    },
  ],
  containers: [
    getContainer(367, 238, 30),
    getContainer(356, 390, -53),
    getContainer(218 - 25, 316, 216.63),
    getContainer(69 - 25, 228, -51.29),
    getContainer(50 - 25, 396, 33.51),
    getContainer(147 - 25, 564, 5),
    getContainer(66 - 30, 733, -38.14),
    getContainer(0 - 20, 880, 5),
    getContainer(116 - 30, 1054, 50.34),
  ],
})

export default data()
